export default defineNuxtPlugin({
  name: 'openfeature',
  setup: async (nuxtApp) => {
    const { loaded, client } = await useOpenFeature()
    nuxtApp.provide('openfeatureLoaded', loaded)
    nuxtApp.provide('openfeature', client)
  },
})
